export default __webpack_public_path__ + "static/travelrapid_step5_hughes-9c65cd594770b733ff9dede05cddd1b0.svg";